"use client";

import { msg } from "@lingui/core/macro";
import { Trans, useLingui } from "@lingui/react/macro";
import { ListFilterPlusIcon } from "lucide-react";
import React from "react";
import { InteractiveCell, InteractiveCellAction } from "./interactive-cell";

type UrlCellProps = {
  url: string | null | undefined;
  onAddFilter?: (url: string) => void;
};

export const UrlCell = ({ url, onAddFilter }: UrlCellProps) => {
  const { t } = useLingui();

  const handleOpenInNewTab = React.useCallback(() => {
    if (url && url !== "N/A") {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  }, [url]);

  const actions: InteractiveCellAction[] = React.useMemo(() => {
    const actionList: InteractiveCellAction[] = [];

    if (onAddFilter && url && url !== "N/A") {
      actionList.push({
        icon: ListFilterPlusIcon,
        onClick: () => onAddFilter(url),
        label: <Trans>Add landing page filter "equals" with this URL</Trans>,
        ariaLabel: t(msg`Add to filter`),
      });
    }

    return actionList;
  }, [onAddFilter, url, t]);

  if (!url) {
    return "-";
  }

  if (url === "N/A") {
    return <span className="text-muted-foreground">{url}</span>;
  }

  return (
    <InteractiveCell
      text={url}
      onClick={handleOpenInNewTab}
      actions={actions}
      textClassName="text-gray-600 dark:text-gray-400 underline decoration-gray-300 dark:decoration-gray-600 underline-offset-2 decoration-1"
      enableTruncate={true}
    />
  );
};
